const profileFileUrl = `https://apiv2.bulletproofforbjj.com/files/`;
const fileUrl = `https://d3742cffkcu4i8.cloudfront.net/`;

// const baseUrl = `http://localhost:3000/api/v1/`;

//staging
// const baseUrl = `https://bjj-staging.castledigital.com.au/api/v1/`;
// const baseUrl = `http://localhost:3000/api/v1/`;
// const baseUrl = `https://api-bulletproof.castledigital.com.au/api/v1/`;

// production (new backend)
const baseUrl = `https://bp-bjj-backend-v2-871334943140.europe-west1.run.app/api/v1/`;

// new backend
// const newBaseUrl = `https://api-auth-bjj.castledigital.com.au/api/v1/`;  // staging-
// const newBaseUrl = `http://localhost:3000/api/v1/`;
// const newBaseUrl = `http://localhost:3004/api/v1/`;
const newBaseUrl = 'https://bp-bjj-backend-new-871334943140.europe-west1.run.app/api/v1/';

export { baseUrl, newBaseUrl, fileUrl, profileFileUrl };
